import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DispatchFreightWorkbenchComponent } from './components/dispatch-freight-workbench/dispatch-freight-workbench.component';
import { DispatchManifestAppendComponent } from './components/dispatch-manifest-append/dispatch-manifest-append.component';

@NgModule({
  declarations: [DispatchFreightWorkbenchComponent, DispatchManifestAppendComponent],
  imports: [CommonModule],
  exports: [DispatchFreightWorkbenchComponent, DispatchManifestAppendComponent],
})
export class DispatchFreightModule {}
